import React, { FC } from 'react';
import { Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';

export interface ListJobPositionProps {
  listItems: Array<any>;
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    ulList: {
      paddingLeft: theme.spacing(2),
      marginTop: 0,
    },
    liItem: {
      color: theme.palette.primary.main,
      fontSize: 10,
      lineHeight: 1.8,
      '& span': {
        color: theme.palette.text.secondary,
        fontSize: 15,
      },
    },
  });
});

const ListJobPosition: FC<ListJobPositionProps> = (props) => {
  const classes = useStyles();
  const { listItems } = props;

  return (
    <>
      <ul className={classes.ulList}>
        {listItems.map((item, index) => (
          <li className={classes.liItem} key={index}>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </>
  );
};

export default ListJobPosition;
